const serviceAreaBoiler = {
    ServiceAreaID: -1,
    ProfitCenterID: -1,
    ServiceAreaShortDesc: "NA",
    ServiceAreaLongDesc: "NA",
    Inactive: false
}
export default serviceAreaBoiler